import requests from "./request";

//获取全部消息
export const GetEntrustInfoList = (param)=>{
    return requests('EntrustInfos?where='+param.where+'&skip='+param.skip+'&take='+param.take,param,'get',0);
}

// 修改状态
export const UpdateByID = (param)=>{
    return requests(`EntrustInfos/${param.ID}`,param,'post',1);
}